import React from 'react';
import Form from '../components/Contact';
import About from '../components/About';

export default function ContactPage() {
  return (
    <>
      <About />
      <h2>Contact Us</h2>
      <Form />
    </>
  );
}
